import styled, { css } from "styled-components";

export const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: var(--white);
  transition: all ease-in-out 0.3s;
  z-index: 4;

  @media (min-width: 992px) {
    left: 85px;
    
  }
  .aside-active & {
  left: 230px;
  @media (min-width: 1450px) {
  left: 290px;

}
}

  .trial-banner-visible & {
    top: 42px;
  }





  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #efefef;
  }

  .header-main-row {
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 0 0;
    gap: 20px;
    
    @media (min-width: 1450px) {
        min-height: 60px;
    padding: 0 20px 0 0;
  }
  }

  .heading-box {
    display: flex;
    align-items: center;
    flex-grow: 1;
    overflow: visible;

    .btn {
      display: inline-block;
      min-width: 130px;
      font: 500 14px/20px var(--roboto-font-serif);
      color: var(--light-gray);
      padding: 15px;
      box-shadow: none;
      outline: none;
      cursor: pointer;
      position: relative;
      border: 0;
      transition: all 0.4s ease-in-out;

      @media (min-width: 1200px) {
        font-size: 16px;
        min-width: 140px;
      }
      @media (min-width: 1450px) {
        padding: 20px 15px;
      }

      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
        width: 0;
        transition: all ease-in-out 0.4s;
      }

      &:hover,
      &.active {
        color: var(--blue);

        &::before {
          width: 100%;
          background: var(--blue);
        }
      }
    }
  }

  .launchpad {
    display: block;
    text-align: center;
    width: 100%;
    font-size: 22px;
    line-height: 25px;
    font-weight: 500;
    letter-spacing: 0.25px;
    color: #313131;
  }

  .edit-name-header {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 0 0 0 20px;
    overflow: visible;

    &.offer-leave-confirm-open {
      position: relative;
      z-index: 5;
    }

    .campaign-name-holder {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .offer-back-wrap {
      position: relative;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      overflow: visible;
      z-index: 5;
    }

    .btn-back {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      font-size: 22px;
      line-height: 1;
      border-radius: 50px;
      background: #f2f4fc;
    }
    .text-wrap {
      display: flex;
      align-items: center;
      gap: 10px;

      .campaign-name {
        display: block;
        font-size: 14px;
        line-height: 17px;
        font-weight: 600;
        color: var(--black);

        @media (min-width: 1440px) {
          font-size: 16px;
          line-height: 19px;
        }
      }

      .campaign-name-input {
        font-size: 16px;
        font-weight: 600;
        border: 1px solid #ddd;
        border-radius: 6px;
        padding: 4px 8px;
        outline: none;
        transition: 0.2s ease;
        width: 100%;
      }

      .edit {
        display: block;
        font-size: 20px;
        line-height: 1;
        color: #e6e7ec;
        cursor: pointer;
      }
    }
    .tag {
      display: block;
      font-size: 14px;
      line-height: 17px;
      font-weight: 500;
      text-transform: capitalize;
      text-align: center;
      color: var(--black);
      padding: 6px 15px;
      border-radius: 50px;
      background: #f2f4fc;

      &.edit-tag {
        margin-left: 25px;
      }

      &.domain-tag {
        padding: 6px 35px;
        background: var(--gray);
        color: var(--light-gray);
      }
    }

    .lead-name,
    .domain-name {
      display: block;
      font-size: 16px;
      line-height: 19px;
      font-weight: 600;
      text-transform: capitalize;
      color: var(--black);
    }

    .domain-name {
      text-transform: lowercase;
    }

    .btn-wrap {
      position: relative;

      .btn-resume,
      .btn-stop {
        min-width: 170px;
        display: flex;
        justify-content: center;
        gap: 10px;
        font-size: 12px;
        line-height: 15px;
        font-weight: 600;
        padding: 8px 10px;
        color: #212325;
        border: 1px solid #e6e7ec;
        border-radius: 50px;
        background: var(--white);

        @media (min-width: 1440px){
          padding: 11px 10px;
        }
      }
    }
  }



  .info-active {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    font-size: 12px;
    line-height: 16px;
    padding: 10px 15px;
    border-radius: 10px;
    border: 1px solid #e6e7ec;
    color: #212325;
    background: var(--white);

    .text {
      display: block;
      position: relative;
      color: #7d8398;
      padding-left: 18px;

      &::before {
        content: "";
        position: absolute;
        top: 1px;
        left: 0;
        width: 12px;
        height: 12px;
        border-radius: 50px;
        background: #2eca8b;
      }
    }
    .date {
      display: block;
      font-weight: 600;
    }
  }

  h1 {
    position: relative;
    font: 500 16px/21px var(--base-font-serif);
    letter-spacing: 0.25px;
    margin: 0;
    padding: 15px;
    color: var(--blue);
    
    @media (min-width: 1450px) {
      padding: 19px 25px;
    }
    
    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 2px;
      background: var(--blue);
    }
  }

  .notificationWraaper {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    color: var(--text-color);
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
    border-radius: 50px;
    background: var(--white);

    @media (max-width: 991px) {
      padding: 0;
      max-width: 40px;
    }

    .bell {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 38px;
      height: 38px;
      border-radius: 50px;
      background: #fafafa;

      @media (min-width: 1440px) {
        width: 40px;
        height: 40px;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }
    .notifcation-text {
      @media (max-width: 991px) {
        display: none;
      }
    }
    .count {
      padding: 4px 12px;
      border-radius: 60px;
      text-align: center;
      color: var(--white);
      background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
      font-size: 13px;
      font-weight: 300;
      line-height: 17px;
      @media (max-width: 991px) {
        display: none;
      }
    }
  }

  .notificationWrapper {
    width: 100%;
    max-width: 330px;
    position: absolute;
    top: 50px;
    right: 30px;
    visibility: hidden;
    transform: translateY(20px);
    opacity: 0;
    transition: 0.4s;
    z-index: 9;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.06);

    @media (max-width: 576px) {
      left: 40px;
    }

    &.notificationWrapper-visible {
      visibility: visible;
      transform: translateY(0);
      opacity: 1;
    }
  }

  .header-right-col {
    display: flex;
    gap: 15px;
    align-items: center;

    .hamburger {
      @media (min-width: 992px) {
        display: none;
      }
    }

    .copilot-btn {
      padding: 8px 20px;
      position: relative;
      background: var(--white);
      border-radius: 8px;

      &::before {
        content: "";
        position: absolute;
        inset: -1px;
        z-index: -1;
        border-radius: inherit;

        background: linear-gradient(
          90deg,
          #367eee 0%,
          #b74bff 50.96%,
          #feb508 100%
        );

      }
    }

    .complete-onboarding-btn {
      padding: 8px 20px;
      border: none;
      cursor: pointer;
      color: var(--white);
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      border-radius: 8px;
      background: linear-gradient(
        90deg,
        #367eee 0%,
        #b74bff 50.96%,
        #feb508 100%
      );

      &:hover {
        opacity: 0.9;
      }
    }

    @media (max-width: 576px) {
      align-items: center;
      justify-content: space-between;
      /* width: 100%; */
    }
  }
`;

export const OfferLeaveConfirmTooltip = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  width: 240px;
  text-align: left;

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 15px;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-bottom-color: #ffffff;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 15px;
    transform: translateX(-50%);
    border: 7px solid transparent;
    border-bottom-color: #e2e8f0;
  }

  p {
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    margin: 0 0 10px;
    line-height: 1.45;
  }

  .confirm-actions {
    display: flex;
    gap: 6px;
    justify-content: flex-start;

    button {
      padding: 5px 12px;
      font-size: 11px;
    }
  }
`;
